<template>
  <v-container fluid>
    <v-card
      class="d-inline-block mx-auto pa-4 ma-10 w-90 position-relative elevation-0"
    >
      <!-- <div class="position-absolute favorite-corner" v-if="isBook" @click="setBookFavoriteForUser">
        <FavoriteRibbon :selected="bookFavoriteForUser" />
      </div> -->
      <v-container>
        <v-row justify="center" class="ma-0">
          <v-col cols="11" lg="4" class="d-flex align-center justify-center">
            <v-img
              :src="`${$utils.globalConstants.BASE_ASSETS_URL}/lbr/image/${book.resourceDir}/cover_medium.jpg`"
              class="border-radius-1 cursor-pointer"
              v-if="!isBook"
              @click="startReading"
            />
            <v-skeleton-loader v-else type="image" width="180" height="250" />
          </v-col>
          <v-col cols="12" lg="8" class="text-center">
            <v-row justify="center" justify-lg="start" class="flex-column ma-0 px-5 align-center">
              <v-col class="px-0 text-left d-flex flex-column" v-if="isBook && allPagesLoaded">
                <v-card-text
                  class="text-subtitle-1 pa-0 brown--text darken-3"
                  data-cy="bookInitCard-author-cardText"
                >
                  <span>{{ author }}</span>
                </v-card-text>
                <v-card-text
                  class="text-h4 brown--text darken-4 pa-0 pr-lg-12"
                  data-cy="bookInitCard-title-cardText"
                >
                  {{ book.title }}
                </v-card-text>
                <v-card-text
                  class="text-body-1 brown--text darken-3 pa-0 pr-lg-12 pt-lg-4"
                  data-cy="bookInitCard-abstract-cardText"
                >
                  {{ book.bookAbstract }}
                </v-card-text>
                <v-card-text class="text-subtitle-1 px-0 brown--text darken-3">
                    <b>{{$t('bookReading.published')}}: </b> {{publishedDate}}.
                </v-card-text>
              </v-col>
              <v-col class="px-0 text-left d-flex flex-column" v-else>
                <v-skeleton-loader type="text" min-width="100" max-width="130" />
                <v-skeleton-loader type="text" min-width="150" max-width="250" />
                <v-skeleton-loader type="text@5" min-width="250" max-width="500" />
              </v-col>

              <!-- <v-col class="px-0" v-if="isBook">
                <v-row class="row d-flex align-center" justify="center">
                  <v-col class="d-flex flex-column justify-start col align-start">
                    <span class="mb-1 font-size-14 brown--text darken-3">
                      {{ ratingMsg(rating) }}
                    </span>
                    <star-rating
                      :star-size="23"
                      :show-rating="false"
                      rounded-corners
                      v-model="rating"
                      read-only
                    />
                  </v-col>
                  <div class="special-border" v-if="showRemainingTime"></div>
                  <v-col class="d-flex flex-row justify-center align-center" v-if="showRemainingTime">
                    <v-img width="30" :src="clock" />
                    <v-card-text class="ml-2 text-left brown--text darken-4 pa-0">
                        {{ daysRemaining }} {{ $t('bookReading.days_to_finish') }}
                      </v-card-text>
                  </v-col>
                  <div class="special-border"></div>
                  <v-col
                    class="d-flex flex-row justify-center align-center cursor-pointer"
                    data-cy="bookInitCard-showAllComments-btn"
                    @click="showAllComments = true"
                  >
                    <v-img width="30" :src="comment"></v-img>
                    <v-card-text class="ml-2 text-left brown--text darken-4 pa-0">
                      {{ countComments }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-col> -->
              <v-col class="px-0" v-else>
                <v-row class="row d-flex align-center" justify="space-between">
                  <div class="px-0 text-left d-flex flex-column mx-5">
                    <v-skeleton-loader type="text@2" width="130" class="ma-0" />
                  </div>
                  <div class="special-border"></div>
                  <v-col class="d-flex flex-row justify-center align-center">
                    <v-skeleton-loader type="avatar" />
                    <v-skeleton-loader type="text" width="50" class="mx-2" />
                  </v-col>
                  <div class="special-border"></div>
                  <v-col class="d-flex flex-row justify-center align-center">
                    <v-skeleton-loader type="avatar" />
                    <v-skeleton-loader type="text" width="50" class="mx-2" />
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col class="px-0" v-if="isBook">
                <v-row class="d-flex flex-row align-center align-lg-start justify-space-around">
                  <x-ArrowButtonOutline
                    :width="'190px'"
                    :height="'10vh'"
                    @brClick="$router.go(-1)"
                  >
                    <span class="gradient-purple-text">{{ $t('go_back') }}</span>
                  </x-ArrowButtonOutline>
                  <x-ArrowButton
                    :width="'200px'"
                    :height="'10vh'"
                    @brClick="startReading"
                    data-cy="bookInitCard-startReading-btn"
                  >
                    <span class="white--text">{{$t('bookReading.start_reading')}}</span>
                  </x-ArrowButton>
                </v-row>
              </v-col> -->
              <v-col class="px-0" v-else>
                <v-row
                  justify="center"
                  justify-lg="start"
                  class="d-flex flex-row align-center align-lg-start"
                >
                  <!-- <v-skeleton-loader type="button" class="mr-6" />
                  <v-skeleton-loader type="button" class="ml-6" /> -->
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <Footer ref="initFooter" v-show="false" v-if="isBook" />
      </v-container>
      <AllCommentsModal
        :dialog="showAllComments"
        :bookTitle="book.title"
        :totalRatings="totalRatings"
        @close-modal="showAllComments = false"
        v-if="isBook && showAllComments"
      />

    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable global-require */
/* eslint-disable no-restricted-globals */

import { mapState, mapActions } from 'vuex'
import global from '@/constants/GlobalConstant'

import FavoriteRibbon from './core/FavoriteRibbon.vue'
import AllCommentsModal from './modals/AllCommentsModal.vue'
import Footer from './content/Footer.vue'

import Author from '../../mixins/author'

export default {
  props: {
    book: { type: Object, default: null },
    avgRating: { type: Number, default: 0 },
    userRating: { type: Object, default: null },
  },
  components: {
    Footer,
    FavoriteRibbon,
    AllCommentsModal,
  },
  data() {
    return {
      clock: require('@/assets/img/icons/clock.svg'),
      comment: require('@/assets/img/icons/comment.svg'),
      showAllComments: false,
      dialogVisible: false
    }
  },
  methods: {
    ...mapActions('bookReading', [
      'setCurrentStage',
      'setCurrentChapterData',
      'setCurrentPage',
      'setCurrentChapter',
      'setBookFavoriteForUser',
    ]),
    startReading() {
      const vm = this
      this.setCurrentStage('bookReading')
      if (
        this.catalog.currentGlobalPage > 0 &&
        this.catalog.progressPercentage !== 100
      ) {
        this.setCurrentChapter(this.catalog.currentChapter)
        this.setCurrentPage(this.catalog.currentPage)
        this.setCurrentChapterData(this.book.bookChapterDTOList[this.currentChapter - 1])
        this.showPage()
      } else if (this.catalog.currentGlobalPage === this.book.structTotalPages) {
        this.$modal.confirm(
          'Confirmación',
          this.$t('bookReading.reread_modal_msg'),
          () => {
            vm.restartBook()
          },
          () => {
            vm.closeDialog()
          }
        )
      }
    },
    restartBook() {
      const vm = this;
      vm.setCurrentChapter(1);
      vm.setCurrentPage(1);
      vm.setCurrentChapterData(this.book.bookChapterDTOList[0]);
      this.showPage();
    },
    closeDialog() {
      this.$router.push('/user/library');
    },
    showPage() {
      setTimeout(() => {
        document.querySelectorAll('.ilustration img').forEach((element, index) => {
          element.setAttribute(
            'src',
            `${global.BASE_URL_BOOK}${this.book.resourceDir}/img/${index + 1}_L.jpg`
          )
        })
      }, 100)

      if (this.book.formatType === 'EPUB') {
        document.querySelectorAll('.bookpage img').forEach((element) => {
          let content = element.getAttribute('src')
          if (content.includes('../')) {
            content = content.replaceAll('../', '')
          }
          element.setAttribute(
            'src',
            `${global.BASE_URL_BOOK}${this.book.resourceDir}/OEBPS/${content}`
          )
        })
      }
      this.$refs.initFooter.getQuestionsForPage()
      this.$ga.event('userClick', 'startReading', 'Begin to read a book')
    },
    ratingMsg(rating) {
      switch (rating) {
        case 3:
          return this.$t('bookReading.good')
        case 4:
          return this.$t('bookReading.very_good')
        case 5:
          return this.$t('bookReading.excellent')
        default:
          return this.$t('bookReading.qualification')
      }
    },
  },
  computed: {
    ...mapState({
      currentStage: (state) => state.bookReading.currentStage,
      currentPage: (state) => state.bookReading.currentPage,
      catalog: (state) => state.bookReading.catalog,
      currentChapter: (state) => state.bookReading.currentChapter,
      currentChapterData: (state) => state.bookReading.currentChapterData,
      bookFavoriteForUser: (state) => state.bookReading.bookFavoriteForUser,
      bookRatingData: (state) => state.bookReading.bookRatingData,
      totalRatings: (state) => state.bookReading.totalRatings,
      epubPagesLoaded: (state) => state.bookReading.epubPagesLoaded,
      pagesLoaded: (state) => state.bookReading.pagesLoaded,
      epubPages: (state) => state.bookReading.epubPages,
    }),
    allPagesLoaded() {
      if (this.book && this.book.bookChapterDTOList) {
        if (this.book.formatType === 'EPUB') {
          return this.epubPagesLoaded === this.epubPages.length
        }
        return this.pagesLoaded === this.book.bookChapterDTOList.length
      }
      return false
    },
    isBook() {
      return this.book !== null
    },
      publishedDate(){
          return this.$utils.capitalizeWord(this.isBook ? `${this.$moment(this.book.entryDate).format('MMMM DD, yy')}` : this.$moment(new Date().getDate()).format('MMMM DD, yy'))
      },
    rating() {
      let result = null
      if (this.userRating) {
        result = this.userRating.rating
      } else {
        result = this.avgRating
      }
      return result
    },
    countComments() {
      let result = null
      if (this.bookRatingData) {
        if (this.bookRatingData.length < 1) result = this.$t('no_comment')
        else if (this.bookRatingData.length > 9) result = this.$t('more_nine_comments')
        else result = `${this.bookRatingData.length} ${this.$t('comments')}`
      } else result = this.$t('no_comment')

      return result
    },
    showRemainingTime() {
      return this.catalog ? this.catalog.assignment === 'TUTOR' : false
    },
    daysRemaining() {
      const eventdate = this.catalog ? this.$moment(this.catalog.evaluationDate) : this.$moment()
      const todaysdate = this.$moment()
      return eventdate.diff(todaysdate, 'days')
    },
    width() {
        if (this.$vuetify.breakpoint.sm) {
            return '80%'
        }
        if (this.$vuetify.breakpoint.md) {
            return '50%'
        }
        if (this.$vuetify.breakpoint.lg) {
            return '40%'
        }
        return 300
    },
  },
  watch:{
    catalog:{
      handler: function (val, oldVal) {
        if (val) {
          this.startReading()
        }
      },
      deep: true
    }
  },
  mixins: [Author],
}
</script>
<style>
.special-border {
  border: 0 dotted;
  border-left: 3px #4e342e;
  height: 4vh;
}
.favorite-corner {
  right: 0;
  top: 0;
}
</style>
